import React from 'react'
import GetRoutes from '@/utils/getRoutes'

//const TeacherManagement = React.lazy(() => import('@/pages/Dashboard/components/TeacherManagement'))
const StudentManagement = React.lazy(() => import('@/pages/Dashboard/components/StudentManagement'))
//const RoleAdd = React.lazy(() => import('@/common/CommonRoleAdd'))
//const RoleDetail = React.lazy(() => import('@/common/CommonRoleDetail/index'))
const LabelManagement = React.lazy(() => import('@/pages/Dashboard/components/system/LabelManagement/index'))
const AccountManagement = React.lazy(() => import('@/pages/Dashboard/components/AccountManagement'))
//const CourseGrading = React.lazy(() => import('@/pages/Dashboard/components/CourseManagement/CourseGrading'))
//const CourseView = React.lazy(() => import('@/pages/Dashboard/components/CourseManagement/CourseView'))
//const CourseDetail = React.lazy(() => import('@/pages/Dashboard/components/CourseManagement/CourseView/components/courseDetail'))
//const OperatePage = React.lazy(() => import('@/pages/Dashboard/components/CourseManagement/CourseView/components/operate'))
// const ReportPage = React.lazy(() => import('@/pages/Dashboard/components/ReportPage/index'))
const ChangePassword = React.lazy(() => import('@/pages/ChangePassword/index'))
const TerminalComponent = React.lazy(() => import('@/pages/Dashboard/components/TerminalComponent/index'))
const ContractIDEComponent = React.lazy(() => import('@/pages/Dashboard/components/ContractIDEComponent/index'))
const ContractIDEBCOSComponent = React.lazy(() => import('@/pages/Dashboard/components/ContractIDEComponent/bcos'))

// 课程管理
const CourseManage = React.lazy(() => import('@/pages/Dashboard/components/CourseManage'))

// 资源管理
const ResouceView = React.lazy(() => import('@/pages/Dashboard/components/ResourceManagement/ResourceList'))
const ResourceDetail = React.lazy(() =>
  import('@/pages/Dashboard/components/ResourceManagement/ResourceList/ResourceDetail')
)
const Courseware = React.lazy(() => import('@/pages/Dashboard/components/ResourceManagement/Courseware'))
const Question = React.lazy(() => import('@/pages/Dashboard/components/ResourceManagement/Question'))

// 插件管理
const PluginManage = React.lazy(() => import('@/pages/Dashboard/components/PluginManage/plug'))

//终端环境管理
const ClusterManage = React.lazy(() => import('@/pages/Dashboard/components/DockerManageent/Cluster'))
const MirrorManage = React.lazy(() => import('@/pages/Dashboard/components/DockerManageent/Mirror'))
const SnapshotManage = React.lazy(() => import('@/pages/Dashboard/components/DockerManageent/nfs'))
const PoolManage = React.lazy(() => import('@/pages/Dashboard/components/DockerManageent/Pool'))
const EnvironmentManage = React.lazy(() => import('@/pages/Dashboard/components/DockerManageent/Environment'))
const InstanceManage = React.lazy(() => import('@/pages/Dashboard/components/DockerManageent/Instance'))
const RecordManage = React.lazy(() => import('@/pages/Dashboard/components/DockerManageent/Record'))

// 教师管理
const TeacherManagementNew = React.lazy(() => import('@/pages/Dashboard/components/system/TeacherManagementNew'))
const TeacherHomeComponent = React.lazy(() => import('@/pages/Dashboard/components/teacher/index'))
const TeacherTaskList = React.lazy(() => import('@/pages/Dashboard/components/teacher/TaskList/index'))
const TeacherTaskDetail = React.lazy(() => import('@/pages/Dashboard/components/teacher/TaskDetail'))
const TeacherScoreReport = React.lazy(() => import('@/pages/Dashboard/components/teacher/ScoreReport/index'))

const HomeComponent = React.lazy(() => import('@/pages/Dashboard/components/HomeComponent/index'))
const TaskList = React.lazy(() => import('@/pages/Dashboard/components/HomeComponent/TaskList/index'))
const TaskDetail = React.lazy(() => import('@/pages/Dashboard/components/HomeComponent/TaskDetail'))
const TeachingTask = React.lazy(() => import('@/pages/Dashboard/components/TeachingManagement/TeachingTask'))
const StudentsTask = React.lazy(() => import('@/pages/Dashboard/components/TeachingManagement/StudentsTask'))
const StudentsTaskDetail = React.lazy(() =>
  import('@/pages/Dashboard/components/TeachingManagement/StudentsTask/detail')
)
const TaskScore = React.lazy(() => import('@/pages/Dashboard/components/TeachingManagement/TaskScore'))
// const TaskScoreDetail = React.lazy(() => import('@/pages/Dashboard/components/TeachingManagement/TaskScore/detail'))
const TaskScoreScore = React.lazy(() => import('@/pages/Dashboard/components/TeachingManagement/TaskScore/score'))
const Debriefing = React.lazy(() => import('@/pages/Dashboard/components/TeachingManagement/Debriefing'))
// const DebriefingDetail = React.lazy(() => import('@/pages/Dashboard/components/TeachingManagement/Debriefing/detail'))
const DebriefingCheck = React.lazy(() =>
  import('@/pages/Dashboard/components/TeachingManagement/Debriefing/checkdebrie')
)
const ScoreReport = React.lazy(() => import('@/pages/Dashboard/components/HomeComponent/ScoreReport/index'))
const StudentManageRun = React.lazy(() => import('@/pages/Dashboard/components/system/StudentManageRun'))

// 管理平台路由配置

const routesList = [
  // { pathname: "/dashboard/system/teacher-management", component: TeacherManagement, name: '教师管理' , type: ['super'], key: '/dashboard/system/teacher-management'},
  // { pathname: "/dashboard/system/teacher-management/add/:type", component: RoleAdd, name: '新增教师信息' , type: ['super'], key: '/dashboard/system/teacher-management' },
  // { pathname: "/dashboard/system/teacher-management/detail/:type/:id", component: RoleDetail, name: '教师信息详情', type: ['super'], key: '/dashboard/system/teacher-management' },

  // { pathname: "/dashboard/student-management", component: StudentManagement, name: '学生管理', type: ['super'], key: '/dashboard/student-management' },
  // { pathname: "/dashboard/student-management/add/:type", component: RoleAdd, name: '新增学生信息', type: ['super'], key: '/dashboard/student-management' },
  // { pathname: "/dashboard/student-management/detail/:type/:id", component: RoleDetail, name: '学生信息详情', type: ['super'], key: '/dashboard/student-management' },

  // { pathname: "/dashboard/course-management/view", component: CourseView, name: '课程查看', type: ['super', 'admin'], key: '/dashboard/course-management/view' },
  // { pathname: "/dashboard/course-management/view/detail/:title/:id", component: CourseDetail, name: '课程详情', type: ['super', 'admin'], key: '/dashboard/course-management/view' },
  // { pathname: "/dashboard/course-management/view/operate/:title/:id", component: OperatePage, name: '操作课程', type: ['super', 'admin'], key: '/dashboard/course-management/view' },
  // { pathname: "/dashboard/course-management/grade", component: CourseGrading, name: '课程打分' , type: ['super', 'admin'], key: '/dashboard/course-management/grade' },

  //个人中心
  {
    pathname: '/dashboard/account',
    name: '个人中心',
    auth: ['super', 'admin', 'teacher', 'student'],
    icon: '',
    hidden: true,
    pid: '0',
    id: '1',
    sort: 1,
    type: 1,
  },
  {
    pathname: '/dashboard/account/info',
    component: AccountManagement,
    name: '账户管理',
    auth: ['super', 'admin', 'teacher', 'student'],
    key: '/dashboard/account/info',
    hidden: true,
    pid: '1',
    id: '1-1',
    sort: 1,
    type: 1,
  },
  {
    pathname: '/dashboard/account/setting',
    component: StudentManagement,
    name: '密码重置',
    auth: ['super', 'admin', 'teacher', 'student'],
    key: '/dashboard/account/setting',
    hidden: true,
    pid: '1',
    id: '1-2',
    sort: 1,
    type: 1,
  },
  {
    pathname: '/dashboard/account/change-password/:id',
    component: ChangePassword,
    name: '修改密码',
    auth: ['super', 'admin', 'teacher', 'student'],
    key: '/dashboard/account/change-password',
    hidden: true,
    pid: '1',
    id: '1-3',
    sort: 1,
    type: 1,
  },

  // 教师任务主页
  {
    pathname: '/dashboard/teacher',
    name: '我的任务',
    auth: ['teacher'],
    icon: 'icon iconfont icon-renwu',
    hidden: false,
    pid: '0',
    id: '2',
    sort: 1,
    type: 1,
  },
  {
    pathname: '/dashboard/teacher/home',
    component: TeacherHomeComponent,
    name: '待完成任务',
    auth: ['teacher'],
    key: '/dashboard/teacher/home',
    hidden: false,
    pid: '2',
    id: '2-1',
    sort: 1,
    type: 1,
  },
  {
    pathname: '/dashboard/teacher/complete',
    component: TeacherHomeComponent,
    name: '已完成任务',
    auth: ['teacher'],
    key: '/dashboard/teacher/complete',
    hidden: false,
    pid: '2',
    id: '2-2',
    sort: 1,
    type: 1,
  },
  {
    pathname: '/dashboard/teacher/home/task/:taskId/:resourceId',
    component: TeacherTaskList,
    name: '任务章节',
    auth: ['teacher'],
    key: '/dashboard/teacher/complete',
    hidden: true,
    pid: '2-1',
    id: '2-1-1',
    sort: 1,
    type: 1,
  },
  {
    pathname: '/dashboard/teacher/home/task-detail/:taskId/:resourceId/:chapterId/:stepId',
    component: TeacherTaskDetail,
    name: '实训中心',
    auth: ['teacher'],
    key: '/dashboard/teacher/home',
    hidden: true,
    pid: '2-1-1',
    id: '2-1-1-1',
    sort: 1,
    type: 1,
  },
  {
    pathname: '/dashboard/teacher/home/score-report/:taskId',
    component: TeacherScoreReport,
    name: '评分报告',
    auth: ['teacher'],
    key: '/dashboard/teacher/complete',
    hidden: true,
    pid: '2-1',
    id: '2-1-2',
    sort: 1,
    type: 1,
  },
  {
    pathname: '/dashboard/teacher/complete/task/:taskId/:resourceId',
    component: TeacherTaskList,
    name: '任务章节',
    auth: ['teacher'],
    key: '/dashboard/teacher/complete',
    hidden: true,
    pid: '2-2',
    id: '2-2-1',
    sort: 1,
    type: 1,
  },
  {
    pathname: '/dashboard/teacher/complete/task-detail/:taskId/:resourceId/:chapterId/:stepId',
    component: TeacherTaskDetail,
    name: '实训中心',
    auth: ['teacher'],
    key: '/dashboard/teacher/complete',
    hidden: true,
    pid: '2-2-1',
    id: '2-2-1-1',
    sort: 1,
    type: 1,
  },
  {
    pathname: '/dashboard/teacher/complete/score-report/:taskId',
    component: TeacherScoreReport,
    name: '评分报告',
    auth: ['teacher'],
    key: '/dashboard/teacher/complete',
    hidden: true,
    pid: '2-2',
    id: '2-2-2',
    sort: 1,
    type: 1,
  },

  // 学生主页
  {
    pathname: '/dashboard/student',
    name: '我的任务',
    auth: ['student'],
    icon: 'icon iconfont icon-renwu',
    hidden: false,
    pid: '0',
    id: '4',
    sort: 1,
    type: 1,
  },
  {
    pathname: '/dashboard/student/home',
    component: HomeComponent,
    name: '待完成任务',
    auth: ['student'],
    key: '/dashboard/student/home',
    hidden: false,
    pid: '4',
    id: '4-1',
    sort: 1,
    type: 1,
  },
  {
    pathname: '/dashboard/student/complete',
    component: HomeComponent,
    name: '已完成任务',
    auth: ['student'],
    key: '/dashboard/student/complete',
    hidden: false,
    pid: '4',
    id: '4-2',
    sort: 1,
    type: 1,
  },
  {
    pathname: '/dashboard/student/home/task/:taskId/:resourceId',
    component: TaskList,
    name: '任务章节',
    auth: ['student'],
    key: '/dashboard/student/home',
    hidden: true,
    pid: '4-1',
    id: '4-1-1',
    sort: 1,
    type: 1,
  },
  {
    pathname: '/dashboard/student/home/task-detail/:taskId/:resourceId/:chapterId/:stepId',
    component: TaskDetail,
    name: '实训中心',
    auth: ['student'],
    key: '/dashboard/student/home',
    hidden: true,
    pid: '4-1-1',
    id: '4-1-1-1',
    sort: 1,
    type: 1,
  },
  {
    pathname: '/dashboard/student/home/score-report/:taskId',
    component: ScoreReport,
    name: '评分报告',
    auth: ['student'],
    key: '/dashboard/student/home',
    hidden: true,
    pid: '4-1',
    id: '4-1-2',
    sort: 1,
    type: 1,
  },

  {
    pathname: '/dashboard/student/complete/task/:taskId/:resourceId',
    component: TaskList,
    name: '任务章节',
    auth: ['student'],
    key: '/dashboard/student/complete',
    hidden: true,
    pid: '4-2',
    id: '4-2-1',
    sort: 1,
    type: 1,
  },
  {
    pathname: '/dashboard/student/complete/task-detail/:taskId/:resourceId/:chapterId/:stepId',
    component: TaskDetail,
    name: '实训中心',
    auth: ['student'],
    key: '/dashboard/student/complete',
    hidden: false,
    pid: '4-2-1',
    id: '4-2-1-1',
    sort: 1,
    type: 1,
  },
  {
    pathname: '/dashboard/student/complete/score-report/:taskId',
    component: ScoreReport,
    name: '评分报告',
    auth: ['student'],
    key: '/dashboard/student/complete',
    hidden: true,
    pid: '4-2',
    id: '4-2-2',
    sort: 1,
    type: 1,
  },

  {
    pathname: '/dashboard/edit',
    component: TerminalComponent,
    name: '自由实验',
    auth: ['student', 'teacher'],
    key: '/dashboard/edit',
    icon: 'icon iconfont icon-shiyan',
    hidden: false,
    pid: '0',
    id: '3',
    sort: 1,
    type: 1,
  },

  {
    pathname: '/dashboard/contract',
    component: ContractIDEComponent,
    name: '智能合约IDE',
    auth: ['student', 'teacher'],
    key: '/dashboard/contract',
    icon: 'icon iconfont icon-heyue',
    hidden: false,
    pid: '0',
    id: '5',
    sort: 1,
    type: 1,
  },
  {
    pathname: '/dashboard/bcos',
    component: ContractIDEBCOSComponent,
    name: '智能合约IDE(BCOS)',
    auth: ['student', 'teacher'],
    icon: 'icon iconfont icon-BCOS',
    hidden: false,
    pid: '0',
    id: '6',
    sort: 1,
    type: 1,
  },

  // 课程管理
  {
    pathname: '/dashboard/course-manage',
    component: CourseManage,
    name: '课程管理',
    auth: ['super', 'admin'],
    icon: 'icon iconfont icon-BCOS',
    hidden: false,
    pid: '0',
    id: '7',
    sort: 1,
    type: 1,
  },
  // {
  //   pathname: '/dashboard/course-management/grade/report/:id/:title',
  //   component: ReportPage,
  //   name: '实训报告',
  //   auth: ['super', 'admin'],
  //   key: '/dashboard/course-management/grade',
  //   hidden: false,
  //   pid: '0',
  //   id: '7',
  //   sort: 1,
  //   type: 1,
  // },

  // 教学管理
  {
    pathname: '/dashboard/teaching-management',
    name: '教学管理',
    auth: ['super', 'admin', 'teacher'],
    icon: 'icon iconfont icon-jiaoxueguanli',
    hidden: false,
    pid: '0',
    id: '8',
    sort: 1,
    type: 1,
  },
  {
    pathname: '/dashboard/teaching-management/teachingtask',
    component: TeachingTask,
    name: '教学任务',
    auth: ['super', 'admin', 'teacher'],
    key: '/dashboard/teaching-management/teachingtask',
    hidden: false,
    pid: '8',
    id: '8-1',
    sort: 1,
    type: 1,
  },

  {
    pathname: '/dashboard/teaching-management/teachingtask/taskscore',
    component: TaskScore,
    name: '任务评分',
    auth: ['super', 'admin', 'teacher'],
    key: '/dashboard/teaching-management/teachingtask/taskscore',
    hidden: true,
    pid: '8-1',
    id: '8-1-1',
    sort: 1,
    type: 1,
  },

  {
    pathname: '/dashboard/teaching-management/teachingtask/debriefing',
    component: Debriefing,
    name: '任务报告',
    auth: ['super', 'admin', 'teacher'],
    key: '/dashboard/teaching-management/teachingtask/debriefing',
    hidden: true,
    pid: '8-1',
    id: '8-1-2',
    sort: 1,
    type: 1,
  },

  {
    pathname: '/dashboard/teaching-management/studentstask/detail/:id',
    component: StudentsTaskDetail,
    auth: ['super', 'admin', 'teacher'],
    name: '进度详情',
    key: '/dashboard/teaching-management/studentstask',
    hidden: true,
    pid: '8-1',
    id: '8-1-1',
    sort: 1,
    type: 1,
  },
  {
    pathname: '/dashboard/teaching-management/studentstask',
    component: StudentsTask,
    name: '学生任务',
    auth: ['super', 'admin', 'teacher'],
    key: '/dashboard/teaching-management/studentstask',
    hidden: false,
    pid: '8',
    id: '8-2',
    sort: 1,
    type: 1,
  },
  {
    pathname: '/dashboard/teaching-management/taskscore',
    component: TaskScore,
    name: '任务评分',
    auth: ['super', 'admin', 'teacher'],
    key: '/dashboard/teaching-management/taskscore',
    hidden: false,
    pid: '8',
    id: '8-3',
    sort: 1,
    type: 1,
  },
  {
    pathname: '/dashboard/teaching-management/taskscore/score/:id/:uid/:stuId',
    component: TaskScoreScore,
    name: '评分设置',
    auth: ['super', 'admin', 'teacher'],
    key: '/dashboard/teaching-management/taskscore',
    hidden: true,
    pid: '8-3',
    id: '8-3-1',
    sort: 1,
    type: 1,
  },
  {
    pathname: '/dashboard/teaching-management/debriefing',
    component: Debriefing,
    name: '任务报告',
    auth: ['super', 'admin', 'teacher'],
    key: '/dashboard/teaching-management/debriefing',
    hidden: false,
    pid: '8',
    id: '8-4',
    sort: 1,
    type: 1,
  },
  {
    pathname: '/dashboard/teaching-management/debriefing/checkbrie/:id/:uid',
    component: DebriefingCheck,
    name: '查看报告',
    auth: ['super', 'admin', 'teacher'],
    key: '/dashboard/teaching-management/debriefing',
    hidden: true,
    pid: '8-4',
    id: '8-4-1',
    sort: 1,
    type: 1,
  },

  // {
  //   pathname: '/dashboard/teaching-management/taskscore/detail/:id',
  //   component: TaskScoreDetail,
  //   name: '任务评分详情',
  //   type: ['super', 'admin', 'teacher'],
  //   key: '/dashboard/teaching-management/taskscore',
  // },

  // {
  //   pathname: '/dashboard/teaching-management/debriefing/detail/:id',
  //   component: DebriefingDetail,
  //   name: '报告详情',
  //   type: ['super', 'admin', 'teacher'],
  //   key: '/dashboard/teaching-management/debriefing',
  // },

  // 资源管理
  {
    pathname: '/dashboard/resource-management/view',
    component: ResouceView,
    name: '资源列表',
    auth: ['super', 'admin', 'teacher'],
    key: '/dashboard/resource-management/view',
    icon: 'icon iconfont icon-ziyuanguanli',
    hidden: false,
    pid: '0',
    id: '9',
    sort: 1,
    type: 1,
  },
  {
    pathname: '/dashboard/resource-management/detail',
    component: ResourceDetail,
    name: '资源详情',
    auth: ['super', 'admin', 'teacher'],
    key: '/dashboard/resource-management/detail',
    hidden: true,
    pid: '9',
    id: '9-1',
    sort: 1,
    type: 1,
  },
  {
    pathname: '/dashboard/resource-management/courseware',
    component: Courseware,
    name: '课件管理',
    auth: ['super', 'admin', 'teacher'],
    key: '/dashboard/resource-management/courseware',
    icon: 'icon iconfont icon-kejianguanli',
    hidden: false,
    pid: '0',
    id: '10',
    sort: 1,
    type: 1,
  },
  // { pathname: "/dashboard/resource-management/mirror", component: Mirror, name: '镜像管理', type: ['super', 'admin', 'teacher'], key: '/dashboard/resource-management/mirror' },
  {
    pathname: '/dashboard/resource-management/question',
    component: Question,
    name: '习题管理',
    auth: ['super', 'admin', 'teacher'],
    key: '/dashboard/resource-management/question',
    icon: 'icon iconfont icon-xitiguanli',
    hidden: false,
    pid: '0',
    id: '11',
    sort: 1,
    type: 1,
  },
  {
    pathname: '/dashboard/PluginManage/plug',
    component: PluginManage,
    name: '插件管理',
    auth: ['super', 'admin', 'teacher'],
    key: '/dashboard/PluginManage/plug',
    icon: 'icon iconfont icon-chajianguanli',
    hidden: false,
    pid: '0',
    id: '12',
    sort: 1,
    type: 1,
  },

  //终端环境管理
  {
    pathname: '/dashboard/docker-management',
    name: '终端环境管理',
    auth: ['super', 'admin', 'teacher'],
    key: '/dashboard/PluginManage/plug',
    icon: 'icon iconfont icon-zhongduanhuanjing',
    hidden: false,
    pid: '0',
    id: '13',
    sort: 1,
    type: 1,
  },

  {
    pathname: '/dashboard/docker-management/cluster',
    component: ClusterManage,
    name: '集群管理',
    auth: ['super', 'admin', 'teacher'],
    key: '/dashboard/docker-management/cluster',
    hidden: false,
    pid: '13',
    id: '13-1',
    sort: 1,
    type: 1,
  },
  {
    pathname: '/dashboard/docker-management/mirror',
    component: MirrorManage,
    name: '镜像列表',
    auth: ['super', 'admin', 'teacher'],
    key: '/dashboard/docker-management/mirror',
    hidden: false,
    pid: '13',
    id: '13-2',
    sort: 1,
    type: 1,
  },
  {
    pathname: '/dashboard/docker-management/nfs',
    component: SnapshotManage,
    name: '持久卷管理',
    auth: ['super', 'admin', 'teacher'],
    key: '/dashboard/docker-management/nfs',
    hidden: false,
    pid: '13',
    id: '13-3',
    sort: 1,
    type: 1,
  },
  {
    pathname: '/dashboard/docker-management/pool',
    component: PoolManage,
    name: 'IP池列表',
    auth: ['super', 'admin', 'teacher'],
    key: '/dashboard/docker-management/pool',
    hidden: false,
    pid: '13',
    id: '13-4',
    sort: 1,
    type: 1,
  },
  {
    pathname: '/dashboard/docker-management/environment',
    component: EnvironmentManage,
    name: '实验环境',
    auth: ['super', 'admin', 'teacher'],
    key: '/dashboard/docker-management/environment',
    hidden: false,
    pid: '13',
    id: '13-5',
    sort: 1,
    type: 1,
  },
  {
    pathname: '/dashboard/docker-management/instance',
    component: InstanceManage,
    name: '实例管理',
    auth: ['super', 'admin', 'teacher'],
    key: '/dashboard/docker-management/instance',
    hidden: false,
    pid: '13',
    id: '13-6',
    sort: 1,
    type: 1,
  },
  {
    pathname: '/dashboard/docker-management/record',
    component: RecordManage,
    name: '实验记录',
    auth: ['super', 'admin', 'teacher'],
    key: '/dashboard/docker-management/record',
    hidden: false,
    pid: '13',
    id: '13-7',
    sort: 1,
    type: 1,
  },

  // 系统管理
  {
    pathname: '/dashboard/system',
    name: '系统管理',
    auth: ['super', 'admin', 'teacher'],
    key: '/dashboard/PluginManage/plug',
    icon: 'icon iconfont icon-shezhi',
    hidden: false,
    pid: '0',
    id: '14',
    sort: 1,
    type: 1,
  },

  // 班级管理
  {
    pathname: '/dashboard/system/label-managemen',
    component: LabelManagement,
    name: '班级管理',
    auth: ['super', 'teacher'],
    key: '/dashboard/system/label-managemen',
    hidden: false,
    pid: '14',
    id: '14-1',
    sort: 1,
    type: 1,
  },
  // 教师管理
  {
    pathname: '/dashboard/system/teacher-management',
    component: TeacherManagementNew,
    name: '教师管理',
    auth: ['super'],
    key: '/dashboard/system/teacher-management',
    hidden: false,
    pid: '14',
    id: '14-2',
    sort: 1,
    type: 1,
  },
  // 学生管理
  {
    pathname: '/dashboard/system/student-managerun',
    component: StudentManageRun,
    name: '学生管理',
    auth: ['super', 'admin', 'teacher'],
    key: '/dashboard/system/student-managerun',
    hidden: false,
    pid: '14',
    id: '14-3',
    sort: 1,
    type: 1,
  },
  // 系统配置
  {
    pathname: '/dashboard/system/env',
    component: React.lazy(() => import('@/pages/Dashboard/components/system/env/index')),
    name: '系统配置',
    auth: ['super', 'admin', 'teacher'],
    key: '/system/env',
    hidden: false,
    pid: '14',
    id: '14-4',
    sort: 1,
    type: 1,
  },
]




export const getRoute = (userType) => {
  const routes = routesList
  const rts = routes.filter((r) => r.auth.includes(userType))
  const GRT = GetRoutes(rts)
  console.log(GRT, '===GRT===')
  return {
    tree:  GRT.tree,
    route: GRT.route
  }
}
// 导航栏配置

// export default [
//   {
//     href: "/dashboard/student",
//     component: "/Dashboard/components/teacher/index",
//     icon: 'icon iconfont icon-renwu',
//     operate: "",
//     pid: "0",
//     id: "1",
//     showFlag: true,
//     sort: 1,
//     systemId: "1",
//     title: "我的任务",
//     type: 1
//   },
//   {
//     href: "/dashboard/student/home",
//     component: "/Dashboard/components/teacher/index",
//     icon: '',
//     operate: "",
//     pid: "1",
//     id: "1-1",
//     showFlag: true,
//     sort: 1,
//     systemId: "1",
//     title: "待完成任务",
//     type: 1
//   },
//   {
//     href: "/dashboard/student/home/task/:taskId/:resourceId",
//     component: "/Dashboard/components/HomeComponent/TaskList/index",
//     icon: '',
//     operate: "",
//     pid: "1",
//     id: "1-1-1",
//     showFlag: false,
//     sort: 1,
//     systemId: "1",
//     title: "任务章节",
//     type: 1
//   },
//   {
//     href: "/dashboard/student/home/task-detail/:taskId/:resourceId/:chapterId/:stepId",
//     component: "/Dashboard/components/teacher/TaskDetail",
//     icon: '',
//     operate: "",
//     pid: "1",
//     id: "1-1-1-1",
//     showFlag: false,
//     sort: 1,
//     systemId: "1",
//     title: "实训中心",
//     type: 1
//   },
//   {
//     href: "/dashboard/student/complete",
//     component: "/Dashboard/components/HomeComponent/index",
//     icon: 'icon iconfont icon-renwu',
//     operate: "",
//     pid: "1",
//     id: "1-2",
//     showFlag: true,
//     sort: 1,
//     systemId: "1",
//     title: "已完成任务",
//     type: 1
//   },
//   {
//     href: "/dashboard/student/complete/task/:taskId/:resourceId",
//     component: '/Dashboard/components/HomeComponent/TaskList/index',
//     icon: '',
//     operate: "",
//     pid: "1",
//     id: "1-2-1",
//     showFlag: false,
//     sort: 1,
//     systemId: "1",
//     title: "任务章节",
//     type: 1
//   },
//   {
//     href: "/dashboard/student/complete/task-detail/:taskId/:resourceId/:chapterId/:stepId",
//     component: '/Dashboard/components/HomeComponent/TaskDetail',
//     icon: '',
//     operate: "",
//     pid: "1",
//     id: "1-2-1-1",
//     showFlag: false,
//     sort: 1,
//     systemId: "1",
//     title: "实训中心",
//     type: 1
//   },
//   {
//     href: "/dashboard/student/complete/score-report/:taskId",
//     component: '/Dashboard/components/HomeComponent/ScoreReport/index',
//     icon: '',
//     operate: "",
//     pid: "1",
//     id: "1-2-2",
//     showFlag: false,
//     sort: 1,
//     systemId: "1",
//     title: "评分报告",
//     type: 1
//   },
// ]
